var _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighVolume1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 121,
    viewBox: "0 0 133 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#99B9D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.232 52.0035C90.8765 52.0035 77.6176 65.2625 77.6176 81.6178C77.6176 89.5752 80.757 96.7988 85.8636 102.12H11.556V30.3629H107.232V52.0035Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 84,
    r: 20,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.339 64.4314C113.459 64.3198 119.496 67.528 122.866 73.3708C127.775 81.8921 125.017 92.5126 116.789 97.276C108.563 102.03 97.9829 99.1293 93.0889 90.616C88.1804 82.0947 90.9601 71.4743 99.186 66.7108C101.751 65.227 104.549 64.4841 107.339 64.4314ZM107.155 57.0716C103.175 57.1421 99.1633 58.1821 95.4962 60.3086C83.738 67.1111 79.8277 82.4133 86.6898 94.3153C93.0938 105.444 106.77 109.884 118.122 104.863L125.973 118.485C126.989 120.258 129.251 120.869 131.022 119.851C132.795 118.821 133.393 116.561 132.377 114.792L124.364 100.873C132.996 93.2356 135.297 80.1524 129.269 69.6755C124.557 61.4893 115.911 56.9171 107.155 57.0716Z",
    fill: "#015294"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2008 11C13.9751 11 7 17.191 7 25.112V92.8294C7 100.75 13.9749 106.941 22.2008 106.941H83.8791C87.8199 106.941 87.8199 101.024 83.8791 101.024H22.2008C16.8546 101.024 12.9058 97.2691 12.9058 92.8294L12.9053 33.2989H105.77V50.6886C105.77 54.6276 111.683 54.6276 111.683 50.6886L111.683 25.112C111.683 17.191 104.701 11 96.4723 11H22.2008Z",
    fill: "#015294"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighVolume1);
export default __webpack_public_path__ + "static/media/High_volume_1.758d84be54a0b05440ca8bb3cde7de04.svg";
export { ForwardRef as ReactComponent };